export const DISCONNECTION_CODES = [2, 3, 11]; // https://github.com/centrifugal/centrifuge-js/blob/master/src/codes.ts#L1-L14